module.exports = __webpack_public_path__ + "img/p02.56b702b9.png";